// extracted by mini-css-extract-plugin
export default {"MatchSuggestionTitle":"MatchSuggestionTitle_MatchSuggestionTitle__W9vkb","emptyState":"MatchSuggestionTitle_emptyState__tyGSV"};